const ItemTypes = {
    Chain: {
        name: 'chain',
        icon: 'group_work',
        addIcon: 'add',
        label: 'label label-warning',
        bsLabel: 'chain',
        canToggle: true,
        canDrag: false,
        translation: 'broker-tree/chain'
    },
    FirmGroup: {
        name: 'firmGroup',
        icon: 'group',
        addIcon: 'group_add',
        label: 'label label-info',
        bsLabel: 'chain-group',
        canToggle: true,
        canDrag: true,
        translation: 'broker-tree/firm-group'
    },
    Firm: {
        name: 'firm',
        icon: 'android',
        addIcon: 'add_box',
        label: 'label label-success',
        bsLabel: 'firm',
        canToggle: true,
        canDrag: true,
        translation: 'broker-tree/firm'
    },
    Agent: {
        name: 'agent',
        icon: 'accessibility',
        addIcon: 'person_add',
        label: 'label label-default',
        bsLabel: 'agent',
        canToggle: false,
        canDrag: true,
        translation: 'broker-tree/agent'
    }
};

export default ItemTypes;
